import React, { useState } from 'react'
import { DropdownButton, DropdownExibition, DropdownIconStyle } from './style'
import dropdownIcon from '../../assets/drop-down-icon.svg'

interface DropdownProps {
  className: string
  isOpen: boolean | boolean[]
  onChange: (value: any | any[]) => void

}

const SimpleDropdown: React.FC<DropdownProps> = ({ isOpen, onChange }) => {

  return (
    <div>
      <DropdownButton className={isOpen ? 'open' : ''} onClick={onChange}>
        <DropdownIconStyle
          className={`${isOpen ? 'active' : ''}`}
          src={dropdownIcon}
        ></DropdownIconStyle>
      </DropdownButton>
    </div>
  )
}

export default SimpleDropdown
